import { loader } from 'graphql.macro'

export default function termsAndCondition ({ dataLoaders, queryKey }) {
  const [, variables] = queryKey
  const schema = loader('./termsAndCondition.graphql')
  return dataLoaders.dispatcher.graphQLClient.request(schema, {
    id: variables.id,
    haulerId: variables.haulerId
  })
}
